module.exports = __webpack_public_path__ + "img/calendar3-week.1a8ca81e.svg";